<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список ВУЗов</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end" v-if="isAdmin()">
        <a class="btn btn-success" href="/universities/0">
          Добавить
        </a>
      </div>
      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по БИН"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="region" class="form-label col-md-3">
              Область ВУЗа
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.regionId" id="region"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="region in regions" :key="region.id"
                        :value="region.id">
                  {{ region.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isNationalUniversity" class="form-label col-md-3">
              Национальный ВУЗ
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.nationalUniversity" id="isNationalUniversity"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isForeignUniversity" class="form-label col-md-3">
              Филиал зарубежного ВУЗа
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.foreignUniversity" id="isForeignUniversity"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="manager" class="form-label col-md-3">
              Менеджер ФЦ
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.managerId" id="manager"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="manager in managers" :key="manager.id" :value="manager.id">
                  {{ manager.lastName }} {{ manager.firstName }} ({{ manager.email }})
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(universityId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityId')"
             :class="{'ascending': page.sort.universityId === 'ASC', 'descending': page.sort.universityId === 'DESC'}">
          ID
        </div>
      </template>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН ВУЗа
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование ВУЗа
        </div>
      </template>
      <template #head(region)="data">
        <div class="sortable-container none"
             @click="onSortChanged('region')"
             :class="{'ascending': page.sort.region === 'ASC', 'descending': page.sort.region === 'DESC'}">
          Область ВУЗа
        </div>
      </template>
      <template #head(actions)="data" v-if="isAdmin()">
      </template>

      <template #cell(universityId)="data">
        {{ data.item.universityId }}
      </template>
      <template #cell(bin)="data">
        {{ data.item.bin }}
      </template>
      <template #cell(nameRu)="data">
        <a :href="`/universities/${data.item.universityId}`">
          {{ data.item.nameRu }}
        </a>
      </template>
      <template #cell(region)="data">
        {{ data.item.region.nameRu }}
      </template>
      <template #cell(actions)="data" v-if="isAdmin()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import universityService from "@/services/universityService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import regionService from "@/services/regionService";
import userService from "@/services/userService";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      page: {
        filter: {
          search: null,
          regionId: null,
          nationalUniversity: null,
          foreignUniversity: null,
          managerId: null
        },
        sort: {
          universityId: null,
          bin: null,
          nameRu: null,
          region: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'universityId', label: 'ID university', sortable: true},
        {key: 'bin', label: 'БИН ВУЗа', sortable: true},
        {key: 'nameRu', label: 'Наименование ВУЗа', sortable: true},
        {key: 'region', label: 'Область ВУЗа', sortable: true},
        {key: 'actions', label: '', sortable: false},
      ],
      items: [],
      regions: [],
      managers: [],
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ]
    };
  },
  methods: {
    isAdmin() {
      return delegationService.isAdmin();
    },
    async reloadList() {
      this.isLoading = true;
      const response = await universityService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await universityService.deleteById(item.universityId);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    async getRegions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      const response = await regionService.getAll(params);
      this.regions = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
    },
    async getAllManagers() {
      const response = await userService.getAllManagers();
      this.managers = response.list;
    }
  },
  mounted() {
    this.reloadList();
    this.getRegions();
    this.getAllManagers();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

</style>
